module.exports = __webpack_public_path__ + "img/case1.917d2136.png";